import { render, staticRenderFns } from "./BrandInfo.vue?vue&type=template&id=20c855ee&scoped=true&"
import script from "./BrandInfo.vue?vue&type=script&lang=js&"
export * from "./BrandInfo.vue?vue&type=script&lang=js&"
import style0 from "./BrandInfo.vue?vue&type=style&index=0&id=20c855ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c855ee",
  null
  
)

export default component.exports